import Toast from '@/frontapp/mixins/actions/Toast'
import { DocumentApi } from '../../test-api/index.ts'
const documentApi = new DocumentApi({}, '/api/v2')
import handleApiError from '../../utils/handleApiError'

export default function (bcDocumentStore, bcFolderStore, $router, $t, replaceRoute = true) {
  const documentId = bcDocumentStore.document.id
  const documentRevId = bcDocumentStore.document.bc_document_rev_id
  
  bcDocumentStore.addToUpdateQueue(() => new Promise((resolve/*, reject*/) => {
    (async () => {
      console.log('document start publish')
      console.time('document publish api call')
      const publishedDocumentResponse = await handleApiError(() => documentApi.documentPublishRevision(documentId, documentRevId))
      console.timeEnd('document publish api call')
      bcDocumentStore.edit = false
      bcFolderStore.updateDocument({ ...publishedDocumentResponse.data, children: null })
      console.time('reload document in published version')
      if (replaceRoute) {
        await $router.replace({ name: 'BCDocumentDetail' })
      }
      console.timeEnd('reload document in published version')
      Toast(
        'success',
        $t('Document was published')
      )
      console.log('document published')
      resolve()
    })()
  }))
}